"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstNonZeroDecimal = exports.toBaseUnit = exports.fromBaseUnit = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const bignumber_1 = require("../bignumber/bignumber");
// Converts from base unit to a precision/ish number
// - If no displayDecimals are provided, it will use the full precision of the number being converted
// - If displayDecimals are provided, it will use that precision, to return e.g a human, precision, or number stripped to any arbitrary decimal places
// and use the ROUND_DOWN rounding mode
const fromBaseUnit = (value, precision, displayDecimals) => {
    const precisionNumber = (0, bignumber_1.bnOrZero)(value).div((0, bignumber_1.bn)(10).pow(precision));
    if (typeof displayDecimals === 'number') {
        return precisionNumber
            .decimalPlaces(displayDecimals, bignumber_js_1.default.ROUND_DOWN)
            .toFixed(displayDecimals);
    }
    return precisionNumber.toFixed();
};
exports.fromBaseUnit = fromBaseUnit;
const toBaseUnit = (amount, precision, roundingMode) => {
    return (0, bignumber_1.bnOrZero)(amount)
        .times((0, bignumber_1.bn)(10).exponentiatedBy((0, bignumber_1.bnOrZero)(precision)))
        .toFixed(0, roundingMode);
};
exports.toBaseUnit = toBaseUnit;
const firstNonZeroDecimal = (number) => {
    return number.toFixed(10).match(/^-?\d*\.?0*\d{0,2}/)?.[0];
};
exports.firstNonZeroDecimal = firstNonZeroDecimal;
